import React from 'react';
import { Link } from 'react-router-dom';

import { openCookieSettings } from '_components/atoms/cookie-consent';
import prmLogoWhite from '_assets/images/gateway/prm-logo-white.png';

const navHeadingStyle = {
  margin: '0 0 18px',
  fontSize: 12,
  fontWeight: 700,
  letterSpacing: '.16em',
  textTransform: 'uppercase',
  color: '#7fbcff',
};

const navListStyle = {
  listStyle: 'none',
  margin: 0,
  padding: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
  fontFamily: 'var(--gw-font-sans)',
};

const footerLinkStyle = { color: '#cdd9ee', fontSize: 15 };

const GatewayFooter = () => {
  return (
    <footer id="footer" style={{ marginTop: 96, background: '#1c2b4a', color: '#fff' }}>
      <div id="gw-footer-grid" style={{ maxWidth: 1240, margin: '0 auto', padding: '66px 32px 40px', display: 'grid', gridTemplateColumns: 'minmax(0, 1.4fr) repeat(3, minmax(0, 1fr))', gap: 48 }}>
        <div>
          <img src={prmLogoWhite} alt="PRM Assist" style={{ height: 32, width: 'auto', display: 'block' }} />
          <p style={{ margin: '22px 0 0', maxWidth: '22em', fontSize: 16, lineHeight: 1.6, color: '#cdd9ee', fontFamily: 'var(--gw-font-sans)' }}>
            The intelligent operating platform for accessible aviation.
          </p>
        </div>
        <nav aria-label="Passengers">
          <p style={navHeadingStyle}>Passengers</p>
          <ul style={navListStyle}>
            <li><Link to={{ pathname: '/passengers', hash: '#download' }} className="gw-footer-link" style={footerLinkStyle}>Download the app</Link></li>
          </ul>
        </nav>
        <nav aria-label="Aviation teams">
          <p style={navHeadingStyle}>Aviation teams</p>
          <ul style={navListStyle}>
            <li><Link to="/request-demo" className="gw-footer-link" style={footerLinkStyle}>Book a demo</Link></li>
          </ul>
        </nav>
        <nav aria-label="Company">
          <p style={navHeadingStyle}>Company</p>
          <ul style={navListStyle}>
            <li><a href="https://connect.prmassist.com/" className="gw-footer-link" style={footerLinkStyle}>Learn More</a></li>
          </ul>
        </nav>
      </div>
      <div style={{ borderTop: '1px solid rgba(127,188,255,0.22)' }}>
        <div id="gw-footer-legal" style={{ maxWidth: 1240, margin: '0 auto', padding: '22px 32px', display: 'flex', gap: 24, flexWrap: 'wrap', alignItems: 'center', fontFamily: 'var(--gw-font-sans)', fontSize: 14, color: '#9fb3d4' }}>
          <span>© {new Date().getFullYear()} PRM Assist</span>
          <Link to="/website-privacy" className="gw-footer-link" style={{ color: '#9fb3d4' }}>Privacy</Link>
          <Link to="/terms" className="gw-footer-link" style={{ color: '#9fb3d4' }}>Terms of use</Link>
          <Link to="/cookies" className="gw-footer-link" style={{ color: '#9fb3d4' }}>Cookies</Link>
          <button type="button" onClick={openCookieSettings} className="gw-footer-link" style={{ padding: 0, border: 0, background: 'none', color: '#9fb3d4', font: 'inherit', cursor: 'pointer' }}>Cookie settings</button>
          <Link to={{ pathname: '/', hash: '#footer' }} className="gw-footer-link" style={{ color: '#9fb3d4' }}>Accessibility statement</Link>
          <span style={{ marginLeft: 'auto' }}>WCAG 2.2 AA target</span>
        </div>
      </div>
    </footer>
  );
};

export default GatewayFooter;
